$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let locationId = $('#location-id').val();
  const isHighlightPage = p === 'statistic_highlight';

  function toggleHighlightProductDetails(productRow) {
    const detailId = productRow.data('detail-id');
    const detailRow = document.getElementById(detailId);
    if (!detailRow) {
      return;
    }

    const isExpanded = productRow.attr('aria-expanded') === 'true';
    productRow.attr('aria-expanded', String(!isExpanded));
    detailRow.classList.toggle('d-none', isExpanded);
  }

  $(document).on('click', '.statistic-highlight-product-row', function () {
    toggleHighlightProductDetails($(this));
  });

  $(document).on(
    'keydown',
    '.statistic-highlight-product-row',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      toggleHighlightProductDetails($(this));
    }
  );

  $('#period-title').text(
    dayFormatAbbreviation(moment().format('ddd - DD.MM.YYYY'))
  );
  if (p === 'statistic_turnover' || isHighlightPage) {
    let isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
      ? 1
      : 0;
    let isIncludingCreditOrder = $('#included_credit_order').is(':checked')
      ? 1
      : 0;
    let isIncludingTipsAmount = $('#included_tips_amount').is(':checked')
      ? 1
      : 0;
    let exportDateData = [];
    let exportTurnoverData = [];
    let exportTurnoverExVatData = [];
    let exportLocationTurnoverDetails = [];
    let totalPriceExVat = 0;
    let totalPriceIncVat = 0;
    let turnoverChart = null;

    $(document).on('click', '#download-statistic-excel', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        url: '/api/v1/private/statistics/download-statistic-excel',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_turnover_data: exportTurnoverData,
          export_turnover_ex_vat_data: exportTurnoverExVatData,
          export_location_turnover_details: exportLocationTurnoverDetails,
          export_type: 'turnover',
          total_turnover_ex_vat: totalPriceExVat,
          total_turnover_inc_vat: totalPriceIncVat,
        }),
        xhrFields: { responseType: 'blob' }, // receive binary data
        success: function (data) {
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
              const filename = `Statistikk omsetning (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  },
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            const blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk omsetning (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;
            link.click();
          }
        },
        error: function () {
          alert('Error generating Excel file');
        },
        complete: function () {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(excel)');
        },
      });
    });

    $(document).on('click', '#download-statistic-pdf', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      var svg = turnoverChart.getSVG();

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        var pngData = canvas.toDataURL('image/png'); // base64 PNG

        // Send AJAX after PNG is ready
        $.ajax({
          url: '/api/v1/private/statistics/download-statistic-pdf',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            export_date_data: exportDateData,
            export_turnover_data: exportTurnoverData,
            export_turnover_ex_vat_data: exportTurnoverExVatData,
            export_location_turnover_details: exportLocationTurnoverDetails,
            export_type: 'turnover',
            total_turnover_ex_vat: totalPriceExVat,
            total_turnover_inc_vat: totalPriceIncVat,
            chart_png: pngData, // send base64 PNG
          }),
          xhrFields: { responseType: 'blob' },
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `statistikk omsetning (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf',
                    },
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk omsetning (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert('Error generating PDF');
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
          },
          complete: function () {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
          },
        });
      };

      img.src =
        'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
    });

    $(document).on('change', '#customer-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      customerId = $(this).val();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    if (deviceWidth < 768) {
      isMobile = true;
    } else if (deviceWidth >= 768 && deviceWidth < 992) {
      isTablet = true;
    } else {
      isDesktop = true;
    }

    $(document).on('change', '#included_credit_order', function () {
      isIncludingCreditOrder = $(this).is(':checked') ? 1 : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#included_tips_amount', function () {
      isIncludingTipsAmount = $(this).is(':checked') ? 1 : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#custom-period', function (e) {
      e.preventDefault();
      customPeriod = $(this).val();
      if (customPeriod == 'day') {
        $('.custom-day-container').removeClass('d-none');
      } else {
        if (!$('.custom-day-container').hasClass('d-none')) {
          $('.custom-day-container').addClass('d-none');
        }
      }
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId,
        selectedDay
      );
    });

    $(document).on('change', '#custom-day', function (e) {
      e.preventDefault();
      selectedDay = $(this).val();
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId,
        selectedDay
      );
    });

    $(document).on('change', '#compare', function (e) {
      e.preventDefault();
      compareBy = $(this).val();

      let isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;

      if (compareBy === 'day-compare') {
        period = 'day';
      } else if (compareBy === 'week-compare') {
        period = 'week';
      } else if (compareBy === 'month-compare') {
        period = 'month';
      } else {
        compareBy = null;
      }
      $(`.period-button[data-value='${period}']`).trigger('click');
    });

    $(document).on('change', '#supplier-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      supplierId = $(this).val();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#product-group-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));

      $('#top-product-group-id')
        .selectpicker('val', ['all'])
        .selectpicker('refresh');

      productGroupUniqueId = $(this).val();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#product-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      productId = $(this).val();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#product-category-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      productCategoryId = $(this).val();

      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#top-product-group-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));

      $('#product-group-id')
        .selectpicker('val', ['all'])
        .selectpicker('refresh');

      topProductGroupUniqueId = $(this).val();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });
    $(document).on('change', '#user-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      userId = $(this).val();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });
    $(document).on('change', '#platform', function (e) {
      e.preventDefault();
      platform = $(this).val();

      if (platform === 'self-service') {
        userId = 0;
        $('#user-id').val(userId);
        $('#user-id').prop('disabled', true);
      } else {
        $('#user-id').prop('disabled', false);
      }
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#payment-method', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      paymentMethod = $(this).val();

      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    const $locationSelect = $('#location-id');
    const $allLocationOption = $locationSelect.find("option[value='all']");
    const $locationOptions = $locationSelect.find('option[value!="all"]');

    if ($allLocationOption.prop('selected')) {
      $locationOptions.prop('selected', true);
    }

    $(document).on('change', '#location-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      locationId = $(this).val();

      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('change', '#vat-code', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      vatCode = $(this).val();
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    $(document).on('click', '.period-button', function (e) {
      $('.period-button').removeClass('active');
      $(this).addClass('active');
      period = $(this).attr('data-value');
      prevSelectedPeriod = period !== 'custom' ? period : prevSelectedPeriod;

      $('#compare').prop('disabled', false);

      if (period === 'day') {
        startDate = moment().format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().format('YYYY-MM-DD') + ' 23:59';
        const currentDayFormatted = moment().format('ddd - DD.MM.YYYY');
        customPeriod = 'time';
        $('#period-title').text(dayFormatAbbreviation(currentDayFormatted));

        if (compareBy && compareBy != 0) {
          compareBy = 'day-compare';
          $('#compare').val('day-compare').trigger('change.select2');
        }
      } else if (period === 'week') {
        startDate = moment().startOf('week').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().endOf('week').format('YYYY-MM-DD') + ' 23:59';
        const currentWeekNumber = moment().isoWeek();
        customPeriod = 'day';
        $(`#custom-period option[value="day"]`).prop('selected', true);
        $('#period-title').text('Uke nr' + ' ' + currentWeekNumber);
        if (compareBy && compareBy !== '0') {
          compareBy = 'week-compare';
          $('#compare').val('week-compare').trigger('change.select2');
        }
      } else if (period === 'month') {
        startDate = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().endOf('month').format('YYYY-MM-DD') + ' 23:59';
        durationOfstartAndEndDate = 30;
        displayGraphDynamically(durationOfstartAndEndDate);
        if (isDesktop) {
          customPeriod = 'day';
          $(`#custom-period option[value="time"]`).prop('selected', false);
          $(`#custom-period option[value="day"]`).prop('selected', true);
        } else {
          customPeriod = 'week';
          $(`#custom-period option[value="day"]`).prop('selected', false);
          $(`#custom-period option[value="week"]`).prop('selected', true);
          $(`#custom-period option[value="day"]`).prop('disabled', true);
        }
        const currentMonth = moment().format('MMMM');
        $('#period-title').text(currentMonth);
        if (compareBy && compareBy !== '0') {
          compareBy = 'month-compare';
          $('#compare').val('month-compare').trigger('change.select2');
        }
      } else if (period === 'year') {
        startDate = moment().startOf('year').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().endOf('year').format('YYYY-MM-DD') + ' 23:59';
        compareBy = null;
        displayGraphDynamically(365);
        customPeriod = 'month';
        $(`#custom-period option[value="time"]`).prop('selected', false);
        $(`#custom-period option[value="month"]`).prop('selected', true);
        $('#period-title').text(moment().format('YYYY'));

        $('#compare').prop('disabled', true);
      } else {
        $('#period-title').text('Custom');
        compareBy = null;
        $('#compare').val('0').trigger('change.select2');
        if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
          customPeriod = 'time';
          $("#custom-period option[value='time']").prop('selected', true);
          $('#custom-period').prop('disabled', true);
          $('#custom-period').val('time').trigger('change');
        } else {
          $("#custom-period option[value='time']").prop('disabled', true);
          $('#custom-period').prop('disabled', false);
        }
      }
      $('#start-date').val(startDate);
      $('#end-date').val(endDate);
      toggleCustomDatePicker();
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;

      if (customPeriod == 'day') {
        $('.custom-day-container').removeClass('d-none');
      } else {
        if (!$('.custom-day-container').hasClass('d-none')) {
          $('.custom-day-container').addClass('d-none');
        }
      }

      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    function getDateAndTimeChange() {
      $('#start-date').datetimepicker({
        dateFormat: 'yy-mm-dd',
        timeFormat: 'HH:mm',
        showButtonPanel: true,
        onClose: function () {
          if (startDate !== $(this).val()) {
            let choosenDate = $('#start-date').val();

            if (dateAndPeriodValidation(choosenDate, endDate)) {
              startDate = choosenDate;
              isDateChanged = true;

              if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
                customPeriod = 'time';
                $("#custom-period option[value='time']").prop('selected', true);
                $('#custom-period').prop('disabled', true);
                $('#custom-period').val('time').trigger('change');
              } else {
                durationOfstartAndEndDate = moment(endDate.split(' ')[0]).diff(
                  moment(startDate),
                  'days'
                );
                displayGraphDynamically(durationOfstartAndEndDate);
                $('#custom-period').prop('disabled', false);
              }
              isIncludingTableTurnOver = $('#include_table_turnover').is(
                ':checked'
              )
                ? 1
                : 0;
              getTurnoverSum(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                customPeriod,
                isIncludingTableTurnOver,
                isIncludingCreditOrder,
                topProductGroupUniqueId,
                customerId,
                compareBy,
                productId,
                vatCode,
                paymentMethod,
                isIncludingTipsAmount,
                productCategoryId
              );
              prevSelectedPeriod = 'custom';
              $('#period-title').text(
                moment(startDate).format('DD-MM-YYYY') +
                  ' : ' +
                  moment(endDate).format('DD-MM-YYYY')
              );
            }
          }
        },
      });

      // Initialize the Datepicker for end-date
      $('#end-date').datetimepicker({
        dateFormat: 'yy-mm-dd',
        timeFormat: 'HH:mm', // 24-hour time format
        showButtonPanel: true,
        onClose: function () {
          if (endDate !== $(this).val()) {
            let currentendDate = $('#end-date').val();

            if (dateAndPeriodValidation(startDate, currentendDate)) {
              isDateChanged = true;
              endDate = currentendDate;
              if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
                $("#custom-period option[value='time']").prop('selected', true);
                $('#custom-period').prop('disabled', true);
                customPeriod = 'time';
              } else {
                durationOfstartAndEndDate = moment(endDate).diff(
                  moment(startDate.split(' ')[0]),
                  'days'
                );
                displayGraphDynamically(durationOfstartAndEndDate);

                $('#custom-period').prop('disabled', false);
              }

              isIncludingTableTurnOver = $('#include_table_turnover').is(
                ':checked'
              )
                ? 1
                : 0;
              getTurnoverSum(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                customPeriod,
                isIncludingTableTurnOver,
                isIncludingCreditOrder,
                topProductGroupUniqueId,
                customerId,
                compareBy,
                productId,
                vatCode,
                paymentMethod,
                isIncludingTipsAmount,
                productCategoryId
              );
              prevSelectedPeriod = 'custom';
              $('#period-title').text(
                moment(startDate).format('DD-MM-YYYY') +
                  ' : ' +
                  moment(endDate).format('DD-MM-YYYY')
              );
            }
          }
        },
      });
    }

    $(document).on('click', '#previous-button', function (e) {
      e.preventDefault();
      let periodTitle = '';
      if (
        period === 'day' ||
        (prevSelectedPeriod === 'day' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = dayFormatAbbreviation(
          moment(startDate).format('ddd - DD.MM.YYYY')
        );
      }
      if (
        period === 'week' ||
        (prevSelectedPeriod === 'week' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'week').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).subtract(1, 'week').format('YYYY-MM-DD') + ' 23:59';
        const currentWeekNumber = moment(startDate).isoWeek();
        periodTitle = 'Uke nr' + ' ' + currentWeekNumber;
      }

      if (
        period === 'month' ||
        (prevSelectedPeriod === 'month' &&
          !isDateChanged &&
          period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'month').format('YYYY-MM-DD') +
          ' 00:00';
        endDate =
          period === 'month'
            ? moment(endDate)
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD') + ' 23:59'
            : moment(endDate).subtract(1, 'month').format('YYYY-MM-DD') +
              ' 23:59';
        periodTitle = moment(startDate).format('MMMM');
      }

      if (
        period === 'year' ||
        (prevSelectedPeriod === 'year' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'year').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).subtract(1, 'year').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = moment(startDate).format('YYYY');
      }

      if (period === 'custom' && prevSelectedPeriod === 'custom') {
        let previousStartDate = moment(startDate);
        let previousEndDate = moment(endDate);

        endDate =
          moment(startDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59';

        durationOfstartAndEndDate = previousEndDate.diff(
          previousStartDate,
          'days'
        );

        startDate =
          moment(endDate)
            .subtract(durationOfstartAndEndDate, 'days')
            .format('YYYY-MM-DD') + ' 00:00';
        periodTitle =
          moment(startDate).format('DD-MM-YYYY') +
          ' : ' +
          moment(endDate).format('DD-MM-YYYY');
      }

      $('#start-date').val(startDate);
      $('#end-date').val(endDate);
      $('#period-title').text(periodTitle);
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
      if (compareBy && compareBy == 'day-compare') {
        let $compare = $('#compare');
        let dayCompareOption = $compare.find("option[value='day-compare']");

        if (dayCompareOption.length) {
          dayCompareOption.text(
            `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
          );
          $compare.val('day-compare');
          $compare.trigger('change.select2');
          $compare.select2('destroy');
          $compare.select2({ theme: 'bootstrap4' });
        }
      }
    });

    $(document).on('click', '#next-button', function (e) {
      e.preventDefault();
      let periodTitle = '';
      if (
        period === 'day' ||
        (prevSelectedPeriod === 'day' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'day').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment(endDate).add(1, 'day').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = dayFormatAbbreviation(
          moment(startDate).format('ddd - DD.MM.YYYY')
        );
      }
      if (
        period === 'week' ||
        (prevSelectedPeriod === 'week' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'week').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).add(1, 'week').format('YYYY-MM-DD') + ' 23:59';
        const currentWeekNumber = moment(startDate).isoWeek();
        periodTitle = 'Uke nr' + ' ' + currentWeekNumber;
      }

      if (
        period === 'month' ||
        (prevSelectedPeriod === 'month' &&
          !isDateChanged &&
          period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'month').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          period === 'month'
            ? moment(endDate)
                .add(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD') + ' 23:59'
            : moment(endDate).add(1, 'month').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = moment(startDate).format('MMMM');
      }

      if (
        period === 'year' ||
        (prevSelectedPeriod === 'year' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'year').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).add(1, 'year').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = moment(startDate).format('YYYY');
      }

      if (period === 'custom' && prevSelectedPeriod === 'custom') {
        let previousStartDate = moment(startDate);
        let previousEndDate = moment(endDate);

        startDate =
          moment(endDate).add(1, 'day').format('YYYY-MM-DD') + ' 00:00';

        durationOfstartAndEndDate = previousEndDate.diff(
          previousStartDate,
          'days'
        );

        endDate =
          moment(startDate)
            .add(durationOfstartAndEndDate, 'days')
            .format('YYYY-MM-DD') + ' 23:59';
        periodTitle =
          moment(startDate).format('DD-MM-YYYY') +
          ' : ' +
          moment(endDate).format('DD-MM-YYYY');
      }
      $('#start-date').val(startDate);
      $('#end-date').val(endDate);
      $('#period-title').text(periodTitle);
      isIncludingTableTurnOver = $('#include_table_turnover').is(':checked')
        ? 1
        : 0;
      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
      if (compareBy && compareBy == 'day-compare') {
        let $compare = $('#compare');
        let dayCompareOption = $compare.find("option[value='day-compare']");

        if (dayCompareOption.length) {
          dayCompareOption.text(
            `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
          );
          $compare.val('day-compare');
          $compare.trigger('change.select2');
          $compare.select2('destroy');
          $compare.select2({ theme: 'bootstrap4' });
        }
      }
    });

    function eventLineChart(categoryArray, seriesData1, seriesData2) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      // Calculate totals for both series when compareBy has value
      let series1Total = 0;
      let series2Total = 0;
      if (compareBy && compareBy !== '0') {
        series1Total = seriesData1.reduce(
          (sum, value) => sum + parseFloat(value),
          0
        );
        series2Total = seriesData2.reduce(
          (sum, value) => sum + parseFloat(value),
          0
        );
      }

      turnoverChart = Highcharts.chart('event-line-graph', {
        chart: {
          type: 'column',
        },
        title: {
          text: null,
        },
        exporting: { enabled: true },
        plotOptions: {
          series: {},
        },
        xAxis: {
          categories: categoryArray,
          labels: {
            formatter: function () {
              if (customPeriod === 'day') {
                return Highcharts.dateFormat(
                  '%e/%b',
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === 'week') {
                return 'Uke ' + this.value;
              } else if (customPeriod === 'month') {
                return Highcharts.dateFormat(
                  '%B %Y',
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: 'Omtsetning (ink mva)',
          },
        },
        series:
          !compareBy || compareBy == '0'
            ? [
                {
                  name: 'Omtsetning',
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
              ]
            : [
                {
                  name: `Omtsetning (${formattedPriceToShowForStatistic(
                    series1Total
                  )}) ${legendText}`,
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
                ...(seriesData2.length > 0
                  ? [
                      {
                        name: `Omtsetning forrige ${getPeriodTranslation(
                          compareBy ?? '',
                          startDate
                        )} (${formattedPriceToShowForStatistic(
                          series2Total
                        )}) ${previousLegendText}`,
                        data: seriesData2.map((value, index) => [
                          categoryArray[index],
                          parseFloat(value),
                        ]),
                      },
                    ]
                  : []),
              ],
        tooltip: {
          formatter: function () {
            let tooltipText;
            if (
              period === 'day' &&
              startDate.split(' ')[0] === endDate.split(' ')[0]
            ) {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%H:%M, %b %e', this.x) +
                '</b><br/>' +
                'Omtsetning: ' +
                formattedPriceToShowForStatistic(this.y, 2);
            } else if (customPeriod === 'week') {
              tooltipText =
                '<b>' +
                'Uke ' +
                this.x +
                '</b><br/>' +
                'Omtsetning: ' +
                formattedPriceToShowForStatistic(this.y, 2);
            } else if (customPeriod === 'month') {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%B - %Y', this.x) +
                '</b><br/>' +
                'Omtsetning: ' +
                formattedPriceToShowForStatistic(this.y, 2);
            } else {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%A, %b %e, %Y', this.x) +
                '</b><br/>' +
                'Omtsetning: ' +
                formattedPriceToShowForStatistic(this.y, 2);
            }
            return tooltipText;
          },
        },
      });
    }

    function dateAndPeriodValidation(startedDate, endedDate) {
      let start = moment(startedDate);
      let end = moment(endedDate);
      durationOfstartAndEndDateByMonths = moment(endedDate.split(' ')[0]).diff(
        startedDate.split(' ')[0],
        'months'
      );

      if (start.isAfter(end)) {
        $('#start-date').val(startDate);
        $('#end-date').val(endDate);
        return alert('end date cannot be later than start date');
      } else if (durationOfstartAndEndDateByMonths > 36) {
        $('#start-date').val(startDate);
        $('#end-date').val(endDate);
        return alert('Maksimal varighet er 3 år');
      } else {
        return true;
      }
    }

    function getHighlightProducts(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      isIncludingCreditOrder,
      customerId,
      topProductGroupUniqueId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId,
      selectedDay
    ) {
      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_product/search',
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          isIncludingCreditOrder,
          customerId,
          topProductGroupUniqueId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          productCategoryId,
          selectedDay,
          orderBy: 'total_price_inc_vat',
          orderByDirection: 'desc',
          highlight: 1,
        },
      }).done(function (data) {
        if (data && data.html) {
          $('#highlight-product-list').removeClass('d-none').html(data.html);
        }
      });
    }

    function getHighlightSummary(requestData) {
      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_payment/search',
        data: requestData,
      }).done(function (data) {
        const paymentFields = {
          card: 'cardCount',
          coupon: 'couponCount',
          cash: 'cashCount',
          credit: 'creditCount',
          vipps: 'vippsCount',
          terminal: 'terminalCount',
          giftcard: 'giftcardCount',
        };
        let paymentTotal = 0;

        Object.entries(paymentFields).forEach(function ([key, field]) {
          const amount = parseFloat(data.paymentCounts?.[field] || 0);
          paymentTotal += amount;
          $(`#highlight-payment-turnover-${key}`).text(
            `${formattedPriceToShowForStatistic(amount)} kr`
          );
        });
        $('#highlight-payment-turnover-total').text(
          `${formattedPriceToShowForStatistic(paymentTotal)} kr`
        );

        ['purchases', 'refunds'].forEach(function (row) {
          const transactionCounts = data.paymentTransactions?.[row] || {};
          const total = parseInt(transactionCounts.total || 0, 10);

          Object.keys(paymentFields).forEach(function (key) {
            const count = parseInt(transactionCounts[key] || 0, 10);
            const percentage = total > 0 ? (count / total) * 100 : 0;
            $(`#highlight-payment-${row}-${key}`).html(
              `<span class="statistic-highlight-summary__percentage">(${formattedPriceToShowForStatistic(percentage)} %)</span> ${count}`
            );
          });
          $(`#highlight-payment-${row}-total`).text(total);
        });
      });

      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_vat/search',
        data: requestData,
      }).done(function (data) {
        const vatAmounts = {
          12: parseFloat(data.reduceVatCount || 0) * 0.12,
          15: parseFloat(data.foodVatCount || 0) * 0.15,
          25: parseFloat(data.regularVatCount || 0) * 0.25,
        };

        Object.entries(vatAmounts).forEach(function ([rate, amount]) {
          $(`#highlight-vat-${rate}`).text(
            `${formattedPriceToShowForStatistic(amount)} kr`
          );
        });
      });
    }

    function getTurnoverSum(
      startDate,
      endDate,
      period = null,
      supplierId = [],
      productGroupUniqueId = [null],
      locationId = '',
      userId = [],
      platform = 'all',
      customPeriod,
      isIncludingTableTurnOver = 0,
      isIncludingCreditOrder = 0,
      topProductGroupUniqueId = [],
      customerId = [],
      compareBy = null,
      productId = [],
      vatCode = [],
      paymentMethod = [],
      isIncludingTipsAmount = 0,
      productCategoryId = [],
      selectedDay = null
    ) {
      if (isHighlightPage) {
        const highlightRequestData = {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          isIncludingCreditOrder,
          customerId,
          topProductGroupUniqueId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          productCategoryId,
          selectedDay,
          highlight: 1,
          isIncludingTableTurnOver,
          isIncludingTipsAmount,
          isIncludingCreditOrder,
        };

        getHighlightProducts(
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          isIncludingCreditOrder,
          customerId,
          topProductGroupUniqueId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          productCategoryId,
          selectedDay
        );
        getHighlightSummary(highlightRequestData);
      }
      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_turnover/search',
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          isIncludingTableTurnOver,
          isIncludingCreditOrder,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          isIncludingTipsAmount,
          productCategoryId,
          selectedDay,
          highlight: isHighlightPage ? 1 : 0,
        },
      })
        .done(function (data) {
          exportLocationTurnoverDetails = data.locationTurnoverDetails ?? [];
          if (data.totalPriceExVat && data.totalPriceIncVat) {
            totalPriceExVat = parseFloat(data.totalPriceExVat);
            totalPriceIncVat = parseFloat(data.totalPriceIncVat);

            if (isHighlightPage) {
              $('#highlight-total-ex-vat').text(
                `${formattedPriceToShowForStatistic(totalPriceExVat)} kr`
              );
              $('#highlight-total-inc-vat').text(
                `${formattedPriceToShowForStatistic(totalPriceIncVat)} kr`
              );
            }

            $('.turnover-ex-vat').text(
              formattedPriceToShowForStatistic(totalPriceExVat)
            );
            $('#key-figure-column-1').attr(
              'data-content',
              parseFloat(totalPriceExVat, 3).toString().replace('.', ',')
            );
            // show tip amount smaller and thicker (bolder)
            if (isIncludingTipsAmount) {
              $('.turnover-inc-vat').html(
                formattedPriceToShowForStatistic(totalPriceIncVat) +
                  ` <span class="tip-amount text-muted" style="font-weight: 500;" >( Tip: ${formattedPriceToShowForStatistic(
                    data.tipsAmount
                  )})</span>`
              );
            } else {
              $('.turnover-inc-vat').text(
                formattedPriceToShowForStatistic(totalPriceIncVat)
              );
            }
            $('#key-figure-column-2').attr(
              'data-content',
              formattedPriceToShowForStatistic(totalPriceIncVat, 3)
                .toString()
                .replace('.', ',')
            );
          } else {
            $('.turnover-ex-vat').text('0');
            $('.turnover-inc-vat').text('0');
            if (isHighlightPage) {
              $('#highlight-total-ex-vat, #highlight-total-inc-vat').text(
                '0,00 kr'
              );
            }
          }

          if (
            data.xAxisArray.length > 0 &&
            data.seriesData1 &&
            data.seriesData2
          ) {
            exportDateData = data.xAxisArray;
            exportTurnoverData = data.seriesData1;

            eventLineChart(data.xAxisArray, data.seriesData1, data.seriesData2);
            if ($('#turn-over-by-location').length) {
              $('#turn-over-by-location').remove();
            }
            $('#line-chart-container').after(data.order_html);
          }

          let aTags = $('.statistic-tab-group a');
          aTags.each(function () {
            let oldHref = $(this).attr('href').split('?')[0];
            let newHref =
              oldHref +
              `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
            $(this).prop('href', newHref);
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function toggleCustomDatePicker() {
      let customDatePicker = $('.custom-date-picker');

      if (period === 'custom') {
        customDatePicker.show();
      } else {
        customDatePicker.hide();
      }
    }

    $(document).on('change', '#include_table_turnover', function () {
      isIncludingTableTurnOver = $(this).is(':checked') ? 1 : 0;
      compareBy = $('#compare').val();

      getTurnoverSum(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        isIncludingTableTurnOver,
        isIncludingCreditOrder,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        isIncludingTipsAmount,
        productCategoryId
      );
    });

    function displayGraphDynamically(durationOfstartAndEndDate) {
      if (isMobile) {
        if (durationOfstartAndEndDate <= 2 && period != 'custom') {
          customPeriod = 'time';
        } else if (durationOfstartAndEndDate <= 7) {
          customPeriod = 'day';
          $("#custom-period option[value='day']").prop('disabled', false);
          $("#custom-period option[value='day']").prop('selected', true);
          $("#custom-period option[value='week']").prop('disabled', false);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").removeClass('disabledOption');
          $("#custom-period option[value='week']").removeClass(
            'disabledOption'
          );
          $('.custom-day-container').removeClass('d-none');
        } else if (
          durationOfstartAndEndDate >= 8 &&
          durationOfstartAndEndDate < 49
        ) {
          //week
          customPeriod = 'week';
          $(`#custom-period option[value="week"]`).prop('selected', true);
          $("#custom-period option[value='week']").prop('disabled', false);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='day']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").addClass('disabledOption');
          $("#custom-period option[value='week']").removeClass(
            'disabledOption'
          );
          $('.custom-day-container').addClass('d-none');
        } else {
          //month
          customPeriod = 'month';
          $(`#custom-period option[value="week"]`).prop('selected', false);
          $(`#custom-period option[value="month"]`).prop('selected', true);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='day']").prop('disabled', true);
          $("#custom-period option[value='week']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").addClass('disabledOption');
          $("#custom-period option[value='week']").addClass('disabledOption');
          $('.custom-day-container').addClass('d-none');
        }
      } else if (isTablet) {
        if (durationOfstartAndEndDate <= 2 && period != 'custom') {
          customPeriod = 'time';
        } else if (durationOfstartAndEndDate <= 180) {
          //day
          customPeriod = 'day';
          $("#custom-period option[value='day']").prop('disabled', false);
          $("#custom-period option[value='day']").prop('selected', true);
          $("#custom-period option[value='week']").prop('disabled', false);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").removeClass('disabledOption');
          $("#custom-period option[value='week']").removeClass(
            'disabledOption'
          );
          $('.custom-day-container').removeClass('d-none');
        } else if (
          durationOfstartAndEndDate >= 181 &&
          durationOfstartAndEndDate < 365
        ) {
          //week
          customPeriod = 'week';
          $(`#custom-period option[value="week"]`).prop('selected', true);
          $("#custom-period option[value='week']").prop('disabled', false);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='day']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").addClass('disabledOption');
          $(".custom-period option[value='week']").removeClass(
            'disabledOption'
          );
          $('#custom-day-container').addClass('d-none');
        } else {
          //month
          customPeriod = 'month';
          $(`#custom-period option[value="week"]`).prop('selected', false);
          $(`#custom-period option[value="month"]`).prop('selected', true);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='day']").prop('disabled', true);
          $("#custom-period option[value='week']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").addClass('disabledOption');
          $("#custom-period option[value='week']").addClass('disabledOption');
          $('.custom-day-container').addClass('d-none');
        }
      } else {
        if (durationOfstartAndEndDate <= 2 && period != 'custom') {
          customPeriod = 'time';
        } else if (durationOfstartAndEndDate <= 180) {
          //day
          customPeriod = 'day';
          $("#custom-period option[value='day']").prop('disabled', false);
          $("#custom-period option[value='day']").prop('selected', true);
          $("#custom-period option[value='week']").prop('disabled', false);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").removeClass('disabledOption');
          $("#custom-period option[value='week']").removeClass(
            'disabledOption'
          );
          $('.custom-day-container').removeClass('d-none');
        } else if (
          durationOfstartAndEndDate >= 181 &&
          durationOfstartAndEndDate < 365
        ) {
          //week
          customPeriod = 'week';
          $(`#custom-period option[value="week"]`).prop('selected', true);
          $("#custom-period option[value='week']").prop('disabled', false);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='day']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").addClass('disabledOption');
          $("#custom-period option[value='week']").removeClass(
            'disabledOption'
          );
          $('.custom-day-container').addClass('d-none');
        } else {
          //month
          customPeriod = 'month';
          $(`#custom-period option[value="week"]`).prop('selected', false);
          $(`#custom-period option[value="month"]`).prop('selected', true);
          $("#custom-period option[value='time']").prop('disabled', true);
          $("#custom-period option[value='day']").prop('disabled', true);
          $("#custom-period option[value='week']").prop('disabled', true);
          $("#custom-period option[value='time']").addClass('disabledOption');
          $("#custom-period option[value='day']").addClass('disabledOption');
          $("#custom-period option[value='week']").addClass('disabledOption');
          $('.custom-day-container').addClass('d-none');
        }
      }
    }
    getTurnoverSum(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      isIncludingTableTurnOver,
      isIncludingCreditOrder,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      isIncludingTipsAmount,
      productCategoryId
    );
    toggleCustomDatePicker();
    getDateAndTimeChange();
  }
});
